import React, { useState, useEffect, useRef } from 'react';
import './Candidate_Page1.css';
import Component_Header_Notification from '../Components/Component_Header_Notification';
import Component_Interview_Slots_Header from '../Components/Component_Interview_Slots_Header';
import Component_Calendar from '../Components/Component_Calendar';
import Candidate_Interview_Timings_Container from '../Components/Candidate_Interview_Timings_Container';
import Candidate_Interview_Slot_Selected from '../Components/Candidate_Interview_Slot_Selected';
import Component_Confirmation_Popup from '../Components/Component_Confirmation_Popup';
import { getInterviewPairings } from '../Requests/Get_Interview_Pairings';
import { getInterviewPairingsExp, InterviewPairingsResponseExp } from '../Requests/Get_Interview_Pairings_Exp';
import { Pairing, InterviewPairingsResponse } from '../Requests/interviewPairings';
import Component_Reschedule_Cancel_Popup from '../Components/Component_Reschedule_Cancel_Popup';
import Component_Withdraw_Application from '../Components/Component_Withdraw_Application';
import Candidate_Slot_Already_Booked from '../Components/Candidate_Slot_Already_Booked';
import CancelledInterview_Page from './CancelledInterview_Page';
import CompletedInterview_Page from './CompletedInterview_Page';
import Component_NoAlternate_Slots from '../Components/Component_NoAlternate_Slots';
import NoSlotsAvailable_Page from './NoSlotsAvailable_Page';
import DuplicateEmail_Page from './DuplicateEmail_Page';
import { getInterviewPairingsPanel, InterviewPairingsResponsePanel } from '../Requests/Get_Interview_Pairings_Panel';


export interface SelectedSlotWithContext {
  requisition_id: string;
  job_title: string;
  pairing: Pairing;
  submission_group_id?: string;
  stage?: string;
  
}

function Candidate_Page1({ 
  candidateEmail, 
  setCandidateEmail, 
  cancelledInterview, 
  setCancelledInterview, 
  refreshTrigger, 
  completedInterview, 
  setCompletedInterview, 
  isExperienced, 
  setIsExperienced, 
  isCampus, 
  setIsCampus,
  duplicateEmail,
  isPanel,
  setIsPanel

}: any) {
  // Campus hire states
  const [pairingsData, setPairingsData] = useState<InterviewPairingsResponse | null>(null);
  
  // Experienced hire states
  const [pairingsDataExp, setPairingsDataExp] = useState<InterviewPairingsResponseExp[] | null>(null);
  const [selectedSubmissionGroup, setSelectedSubmissionGroup] = useState<string>('');
  const [bookedStages, setBookedStages] = useState<Set<string>>(new Set());
  
  const [loading, setLoading] = useState<boolean>(true);
  const [selectedDates, setSelectedDates] = useState<Date[]>([]);
  const [currentMonth, setCurrentMonth] = useState<Date | null>(null);
  const [selectedPage, setSelectedPage] = useState<string>('calendar');
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState<SelectedSlotWithContext | null>(null);
  const [showReschedulePopup, setShowReschedulePopup] = useState(false);
  const [showCandidateSlotAlreadyBooked, setCandidateSlotAlreadyBooked] = useState(false);
  const [showWithdrawPopup, setShowWithdrawPopup] = useState(false);
  const [rescheduleClicked, setIsRescheduledClicked] = useState<boolean>(false);
  const [noAlternateRescheduleSlots, setnoAlternateRescheduleSlots] = useState<boolean>(false);
  const [noSlotsAvailable, setnoSlotsAvailable] = useState<boolean>(false);
  const [reschedulingReason, setReschedulingReason] = useState<string>("");
  const [pairingsDataPanel, setPairingsDataPanel] = useState<InterviewPairingsResponsePanel | null>(null);

  // Get current pairings data based on candidate type
  const getCurrentPairingsData = () => {
    if (isPanel && pairingsDataPanel) {
      return pairingsDataPanel;
    }
    if (isExperienced && pairingsDataExp && selectedSubmissionGroup) {
      return pairingsDataExp.find(group => 
        group.pairings[0]?.submission_group_id === selectedSubmissionGroup
      );
    }
    return pairingsData;
  };

  // Get available stages for dropdown
  const getAvailableStages = () => {
    if (!pairingsDataExp) return [];
    
    const stagesMap = new Map<string, { stage: string; type: string; submission_group_id: string; interview_paired: boolean }>();
    
    pairingsDataExp.forEach(group => {
      const firstPairing = group.pairings[0];
      if (firstPairing && !stagesMap.has(firstPairing.submission_group_id)) {
        stagesMap.set(firstPairing.submission_group_id, {
          stage: firstPairing.stage,
          type: firstPairing.interview_1_type || 'Unknown',
          submission_group_id: firstPairing.submission_group_id,
          interview_paired: group.interview_paired
        });
      }
    });
    
    return Array.from(stagesMap.values()).sort((a, b) => 
      parseInt(a.stage) - parseInt(b.stage)
    );
  };

  // Check if all stages are booked
  const areAllStagesBooked = () => {
    if (!pairingsDataExp) return false;
    return pairingsDataExp.every(group => group.interview_paired);
  };

  const refreshPairings = async (forceSubmissionGroup?: string) => {
  if (!candidateEmail) return;

  if (isPanel) {
    console.log("calling panel api");
    const data = await getInterviewPairingsPanel(rescheduleClicked);
    if (data && data.pairings && data.pairings.length > 0) {
      setPairingsDataPanel(data);
    }
    return;
  }

  if (isExperienced) {
    const data = await getInterviewPairingsExp(rescheduleClicked);
    if (data) {
      setPairingsDataExp(data);
      const booked = new Set<string>();
      data.forEach(group => {
        if (group.interview_paired && group.pairings[0]) {
          booked.add(group.pairings[0].submission_group_id);
        }
      });
      setBookedStages(booked);

      if (forceSubmissionGroup) {
        setSelectedSubmissionGroup(forceSubmissionGroup);
      } else if (rescheduleClicked && selectedSlot?.submission_group_id) {
        setSelectedSubmissionGroup(selectedSlot.submission_group_id);
      } else if (!selectedSubmissionGroup || booked.has(selectedSubmissionGroup)) {
        const firstUnbooked = data.find(g => !g.interview_paired);
        if (firstUnbooked && firstUnbooked.pairings[0]) {
          setSelectedSubmissionGroup(firstUnbooked.pairings[0].submission_group_id);
        } else if (data.length > 0 && data[0].pairings[0]) {
          setSelectedSubmissionGroup(data[0].pairings[0].submission_group_id);
        }
      }
    }
  } else {
    const data = await getInterviewPairings(candidateEmail, rescheduleClicked);
    // GUARD: only set if data exists
    if (data) setPairingsData(data);
  }
};

// Fetch data on mount and refresh
useEffect(() => {
  if (!isExperienced && !isCampus && !isPanel) {
    console.log('Waiting for candidate type to be determined...');
    return;
  }
  const fetchData = async () => {
  if (!candidateEmail) return;

  if (!isExperienced && !isCampus && !isPanel) {
    console.log('Waiting for candidate type to be determined...');
    return;
  }

  if (rescheduleClicked && selectedSlot?.submission_group_id) {
    console.log('Skipping useEffect during reschedule - will be handled by handleReschedule');
    return;
  }

  setLoading(true);

  if (isPanel) {
    console.log("calling panel api");
    const data = await getInterviewPairingsPanel(rescheduleClicked);
    if (!data || !data.pairings || data.pairings.length === 0) {
      setnoSlotsAvailable(true);
    } else {
      setPairingsDataPanel(data);
    }
  } else if (isExperienced) {
    console.log("calling experienced api");
    const data = await getInterviewPairingsExp(rescheduleClicked);
    if (!data || data.length === 0) {
      setnoSlotsAvailable(true);
    } else {
      setPairingsDataExp(data);
      const booked = new Set<string>();
      data.forEach(group => {
        if (group.interview_paired && group.pairings[0]) {
          booked.add(group.pairings[0].submission_group_id);
        }
      });
      setBookedStages(booked);

      const firstUnbooked = data.find(g => !g.interview_paired);
      if (firstUnbooked && firstUnbooked.pairings[0]) {
        setSelectedSubmissionGroup(firstUnbooked.pairings[0].submission_group_id);
      } else if (data.length > 0 && data[0].pairings[0]) {
        setSelectedSubmissionGroup(data[0].pairings[0].submission_group_id);
      }
    }
  } else {
    console.log("calling campus api");
    const data = await getInterviewPairings(candidateEmail, rescheduleClicked);
    // GUARD: check data and data.pairings exist before accessing .length
    if (!data || !data.pairings || data.pairings.length === 0) {
      setnoSlotsAvailable(true);
    }
    if (data) setPairingsData(data);
  }

  setLoading(false);
};
  fetchData();
}, [candidateEmail, refreshTrigger, rescheduleClicked, isExperienced, isCampus, isPanel]); // ADD isCampus here

  // Refetch when returning to calendar page
  useEffect(() => {
    if (selectedPage === 'calendar') {
      const currentData = getCurrentPairingsData();
      if (currentData?.interview_paired) {
        const refetch = async () => {
          if (!candidateEmail) return;
          console.log('refetch on calendar page');
          
          if (isPanel) {
            console.log("calling panel api");
            const data = await getInterviewPairingsPanel(rescheduleClicked);
            if (data) setPairingsDataPanel(data);
          }
          else if (isExperienced) {
            console.log("calling experienced api");
            const data = await getInterviewPairingsExp(rescheduleClicked);
            if (data) {
              setPairingsDataExp(data);
              const booked = new Set<string>();
              data.forEach(group => {
                if (group.interview_paired && group.pairings[0]) {
                  booked.add(group.pairings[0].submission_group_id);
                }
              });
              setBookedStages(booked);
            }
          } else {
            console.log("calling campus api")
            const data = await getInterviewPairings(candidateEmail, rescheduleClicked);
            if (data) setPairingsData(data);
          }
        };
        refetch();
      }
    }
  }, [selectedPage, rescheduleClicked, isExperienced, isPanel]);

  // Set initial month from first pairing
  // Set initial month from first pairing
useEffect(() => {
  const currentData = getCurrentPairingsData();
  if (currentData && Array.isArray(currentData.pairings) && currentData.pairings.length > 0) {
    const firstStartTime = currentData.pairings[0].start_time;
    if (firstStartTime) {
      const parsedDate = new Date(firstStartTime);
      const firstOfMonth = new Date(parsedDate.getFullYear(), parsedDate.getMonth(), 1);
      setCurrentMonth(firstOfMonth);
    }
  }
}, [pairingsData, pairingsDataExp, pairingsDataPanel, selectedSubmissionGroup]); // ADD pairingsDataPanel

  const interviewTimingsRef = useRef<HTMLDivElement>(null);

// Add this useEffect to handle scroll on mobile when dates are selected
useEffect(() => {
  if (selectedDates.length > 0 && window.innerWidth <= 768 && interviewTimingsRef.current) {
    setTimeout(() => {
      interviewTimingsRef.current?.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }, 100);
  }
}, [selectedDates]);

  const handleSelectionChange = (dates: Date[]): void => {
    setSelectedDates(dates);
  };

  const handleMonthChange = (month: Date): void => {
    setCurrentMonth(month);
  };

  const handleNotificationAction = (): void => {
    console.log('Notification action clicked');
  };

  const handleSlotClick = (slot: SelectedSlotWithContext) => {
    if (slot.pairing.slot_available) {
      // Add submission_group_id and stage for experienced candidates
      if (isExperienced && selectedSubmissionGroup) {
        const currentGroup = pairingsDataExp?.find(g => 
          g.pairings[0]?.submission_group_id === selectedSubmissionGroup
        );
        if (currentGroup && currentGroup.pairings[0]) {
          slot.submission_group_id = currentGroup.pairings[0].submission_group_id;
          slot.stage = currentGroup.pairings[0].stage;
        }
      }
      setSelectedSlot(slot);
      setShowConfirmationPopup(true);
    }
  };

  const handleRescheduleCancelSlot = () => {
    setShowReschedulePopup(true);
  };

  const handleStageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    // Prevent stage change during reschedule mode
    if (rescheduleClicked && selectedSlot?.submission_group_id && 
        e.target.value !== selectedSlot.submission_group_id) {
      return; // Don't allow changing to other stages during reschedule
    }
    setSelectedSubmissionGroup(e.target.value);
    setSelectedDates([]); // Clear selected dates when changing stage
  };

  if (loading) {
    return <div className='main-candidate-page-container'></div>;
  }

  const currentData = getCurrentPairingsData();
  if (!currentData && !isExperienced) {
    return <div className='main-candidate-page-container'></div>;
  }

  const stages = isExperienced ? getAvailableStages() : [];
  const showDropdown = isExperienced && stages.length > 1;

  const normalizeToSingleResponse = (
  data: InterviewPairingsResponse | InterviewPairingsResponseExp | InterviewPairingsResponsePanel | null | undefined
): InterviewPairingsResponse | null => {
  if (!data) return null;
  if ('interview_paired' in data && !Array.isArray(data)) {
    // Map PairingPanel[] or PairingExp[] to Pairing[] shape
    return {
      ...data,
      pairings: data.pairings.map((p: any) => ({
        ...p,
        stage: String(p.stage), // normalize stage to string
      })),
    } as InterviewPairingsResponse;
  }
  return null;
};

  return (
    <div className='main-candidate-page-container'>
      {cancelledInterview || selectedPage === 'cancel_page' ? (
        <CancelledInterview_Page 
          recruiterEmail={currentData?.pairings[0]?.recruiter_email} 
          recruiterName={currentData?.pairings[0]?.recruiter_name} 
        />
      ) : completedInterview ? (
        <CompletedInterview_Page 
          recruiterEmail={currentData?.pairings[0]?.recruiter_email} 
          recruiterName={currentData?.pairings[0]?.recruiter_name} 
        />
      ) : noSlotsAvailable ? (
        <NoSlotsAvailable_Page />
      ) : duplicateEmail ? (
        <DuplicateEmail_Page />
      ) : (
        <>
          {showConfirmationPopup && selectedSlot && (
            <Component_Confirmation_Popup 
              setSelectedPage={setSelectedPage} 
              setShowConfirmationPopup={setShowConfirmationPopup} 
              slot={selectedSlot}
              candidateEmail={candidateEmail}
              refreshPairings={refreshPairings}
              setSelectedSlot={setSelectedSlot}
              rescheduleClicked={rescheduleClicked}
              setIsRescheduledClicked={setIsRescheduledClicked}
              isExperienced={isExperienced}
              isCampus={isCampus}
              reschedulingReason={reschedulingReason}
              setReschedulingReason={setReschedulingReason}
              setCandidateSlotAlreadyBooked={setCandidateSlotAlreadyBooked}
              allStagesBooked={areAllStagesBooked()}
              currentStage={selectedSlot.stage}
              isPanel={isPanel} 
            />
          )}
          {noAlternateRescheduleSlots && (
            <Component_NoAlternate_Slots setnoAlternateRescheduleSlots={setnoAlternateRescheduleSlots}/>
          )}
          {showReschedulePopup && (
            <Component_Reschedule_Cancel_Popup 
              slot={
                // Use selectedSlot if available (from reschedule button click), otherwise use currentData
                selectedSlot || (currentData ? {
                  requisition_id: currentData.requisition_id,
                  job_title: currentData.job_title,
                  pairing: currentData.pairings[0],
                  submission_group_id: isExperienced && currentData.pairings[0] && 'submission_group_id' in currentData.pairings[0] ? currentData.pairings[0].submission_group_id : undefined,
                  stage: isExperienced && currentData.pairings[0] && 'stage' in currentData.pairings[0] ? currentData.pairings[0].stage : undefined
                } : null)
              }
              candidateEmail={candidateEmail} 
              setSelectedPage={setSelectedPage}
              setSelectedDates={setSelectedDates}
              setSelectedSlot={setSelectedSlot}
              refreshPairings={refreshPairings} 
              setShowReschedulePopup={setShowReschedulePopup}
              setCancelledInterview={setCancelledInterview}
              setIsRescheduledClicked={setIsRescheduledClicked}
              isExperienced={isExperienced}
              isCampus={isCampus}
              noAlternateRescheduleSlots={noAlternateRescheduleSlots}
              setnoAlternateRescheduleSlots={setnoAlternateRescheduleSlots}
              reschedulingReason={reschedulingReason}
              setReschedulingReason={setReschedulingReason}
              isPanel={isPanel}
            />
          )}
          {showCandidateSlotAlreadyBooked && (
            <Candidate_Slot_Already_Booked setSlotAlreadyBookedPopup={setCandidateSlotAlreadyBooked}/>
          )}
          {showWithdrawPopup && currentData && (
            <Component_Withdraw_Application
              slot={{
                requisition_id: currentData.requisition_id,
                job_title: currentData.job_title,
                pairing: currentData.pairings[0],
              }}
              candidateEmail={candidateEmail}
              setSelectedPage={setSelectedPage}
              setCancelledInterview={setCancelledInterview}
              setShowWithdrawPopup={setShowWithdrawPopup}
              isExperienced={isExperienced}
              isCampus={isCampus}
              isPanel={isPanel}
            />
          )}

          {selectedPage === 'calendar' && (!currentData?.interview_paired || rescheduleClicked) ? (
            <>
              <div className={`candidate-page1-container ${selectedDates.length > 0 ? 'half-width' : ''}`}>
                <div className='candidate-page1-notification-section'>
                  <Component_Header_Notification 
                    onActionClick={handleNotificationAction} 
                    pairingsData={normalizeToSingleResponse(currentData)}
                  />
                </div>
                <div className='candidate-page1-main-content'>
                  <div className='candidate-page1-header-section'>
                    <Component_Interview_Slots_Header />
                    {showDropdown && (
                      <div className='stage-dropdown-container'>
                        <select 
                          value={selectedSubmissionGroup} 
                          onChange={handleStageChange}
                          className='stage-dropdown'
                        >
                          {stages.map((stageInfo, index) => (
                            <option 
                              key={stageInfo.submission_group_id} 
                              value={stageInfo.submission_group_id}
                              disabled={
                                stageInfo.interview_paired || 
                                (rescheduleClicked && selectedSlot?.submission_group_id !== stageInfo.submission_group_id)
                              }
                            >
                              {stageInfo.type} {stageInfo.interview_paired ? '✓' : ''}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                  </div>
                  <div className='candidate-page1-calendar-section'>
                    {currentMonth && currentData && (
                      <Component_Calendar 
                        pairingsData={normalizeToSingleResponse(currentData)!}
                        onSelectionChange={handleSelectionChange}
                        currentMonth={currentMonth}
                        onMonthChange={handleMonthChange}
                      />
                    )}
                  </div>
                </div>
              </div>
              
              {selectedDates.length > 0 && currentData && (
                <div 
                  ref={interviewTimingsRef}
                  className='candidate-page1-interview-timings'
                >
                  <Candidate_Interview_Timings_Container 
                    pairingsData={normalizeToSingleResponse(currentData)!}
                    selectedDates={selectedDates}
                    onSlotClick={handleSlotClick}
                    rescheduleClicked={rescheduleClicked}
                    setIsRescheduledClicked={setIsRescheduledClicked}
                    setSelectedPage={setSelectedPage}
                  />
                </div>
              )}
            </>
          ) : currentData && (
            <Candidate_Interview_Slot_Selected 
              slot={
                selectedSlot ||
                (currentData.pairings?.length > 0
                  ? {
                      requisition_id: currentData.requisition_id,
                      job_title: currentData.job_title,
                      pairing: currentData.pairings[0]
                    }
                  : null)
              }
              candidateEmail={candidateEmail}
              setSelectedPage={setSelectedPage}
              setSelectedDates={setSelectedDates}
              setSelectedSlot={setSelectedSlot}
              refreshPairings={refreshPairings}
              onRescheduleClick={() => setShowReschedulePopup(true)}
              onWithdrawClick={() => setShowWithdrawPopup(true)}
              isExperienced={isExperienced} 
              isPanel={isPanel}
            />
          )}
        </>
      )}
    </div>
  );
}

export default Candidate_Page1;